import { observer } from "mobx-react-lite"
import BlockBase from "./base"
import BlockState from "pages/scheme-editor/store/block"
import BlockInfo from "./base-info"
import ListValues from "components/controls/list"
import { FormControlLabel, Checkbox } from "@mui/material"

const BlockSelectable = observer(({ state }: { state: BlockState }) => {
  
  return (
    <BlockBase state={state}>
      <BlockInfo state={state}>
        <ListValues 
          values={state.emitters} 
          setValues={values => state.setEmitters(values)}
          sx={{ mb: 0.5 }}
        />
        <FormControlLabel control={<Checkbox {...state.checkboxProps('useAsKey', false)} />} label="Использ. ключ в дочерних" />
      </BlockInfo>
    </BlockBase>
  )
})

export default BlockSelectable